import { Lightbox } from "@msuite/ui/lightbox";
import { AnnotatedLightboxItem } from "./annotated-lightbox-item";
import { AnnotatedLightboxProvider } from "./annotated-lightbox-provider";

/**
 * Drop-in replacement for `Lightbox` that wires every image item to the file
 * annotation capability (view/edit annotations) and shows an annotation hint badge.
 *
 * Pass all lightbox file ids to `AnnotatedLightbox.Provider` via `fileIds` so the
 * "has annotations" hint can be resolved in a single batch request.
 */
const AnnotatedLightbox: {
	Provider: typeof AnnotatedLightboxProvider;
	Container: typeof Lightbox.Container;
	Item: typeof AnnotatedLightboxItem;
} = {
	Provider: AnnotatedLightboxProvider,
	Container: Lightbox.Container,
	Item: AnnotatedLightboxItem,
};

export { AnnotatedLightbox };
